import { formatCityState } from './formatCityState'

type Props =
    | { city?: string | null | undefined; state?: string | null | undefined; zip?: string | null | undefined }
    | null
    | undefined

export const formatCityStateZip = (location: Props): string => {
    if (!location) {
        return ''
    }

    const formattedCityState = formatCityState(location)

    const { zip } = location

    if (!zip) {
        return formattedCityState
    }

    const formattedZip = typeof zip === 'string' ? zip.toUpperCase() : zip

    return `${formattedCityState} ${formattedZip}`
}
